import * as React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

const SIZE_REGEX = /(?:modal|simple-modal|placeholder-modal)__content(?:--|-)(full|lg|md|sm)\b/;
const CONTENT_TOKEN_REGEX = /(?:modal|simple-modal|placeholder-modal)__content(?:--|-)[^\s]*/g;
const NOISE_WORD_REGEX = /\b(?:simple-modal|placeholder-modal|modal)\b\s*(?:active\b)?/g;

function extractSizeAndClassName(contentClassName) {
  if (!contentClassName) return { size: 'default', className: '' };

  const sizeMatch = contentClassName.match(SIZE_REGEX);
  const detectedSize = sizeMatch ? sizeMatch[1] : 'default';

  const remaining = contentClassName
    .replace(CONTENT_TOKEN_REGEX, '')
    .replace(NOISE_WORD_REGEX, '')
    .replace(/\s+/g, ' ')
    .trim();

  return { size: detectedSize, className: remaining };
}

function LegacyModalAdapter({
  show,
  onClose,
  children,
  contentClassName,
  hideCloseButton,
  closeOnOverlayClick = true,
  id
}) {
  const { size, className } = extractSizeAndClassName(contentClassName);

  const handleOpenChange = React.useCallback(
    (open) => {
      if (!open && onClose) {
        onClose();
      }
    },
    [onClose]
  );

  const handleInteractOutside = React.useCallback(
    (event) => {
      if (!closeOnOverlayClick) {
        event.preventDefault();
      }
    },
    [closeOnOverlayClick]
  );

  return (
    <Dialog open={show} onOpenChange={handleOpenChange}>
      <DialogContent
        size={size}
        hideCloseButton={hideCloseButton}
        className={cn(className)}
        onInteractOutside={handleInteractOutside}
        id={id}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}

LegacyModalAdapter.displayName = 'LegacyModalAdapter';

export default LegacyModalAdapter;
